import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

import samplePageStore from './sample/samplePage/samplePageStore';
import gridSampleStore from './sample/gridSample/gridSampleStore';
import gridExmplStore from './sample/gridExmpl/gridExmplStore';
import accKeySummaryStore from './accKey/summary/accKeySummaryStore';
import accKeyDetailsStore from './accKey/details/accKeyDetailsStore';
import accKeyExceptionStore from './accKey/exception/accKeyExceptionStore';
import accKeyListStore from './accKey/list/accKeyListStore';
import breadCrumbStore from './common/breadCrumb/breadCrumbStore';
import userdivStore from './userdiv/userdivStore';
import commonStore from './common/common/commonStore';
import webClientStore from './webClient/webClientStore';
import remProjectStore from './rem/project/projectStore';
import remRegionStore from './rem/region/regionStore';
import remUserStore from './rem/user/remUserStore';
import remLogStore from './rem/log/logStore';
import remDivisionStore from './rem/division/divisionStore';
import accountDivisionStore from './monitoring/cloudaccount/summary/accountDivisionStore';
import accountDetailStore from './monitoring/cloudaccount/detail/accountDetailStore';
import accountStatusStore from './monitoring/cloudaccount/status/accountStatusStore'
import myHomeStore from './home/myHomeStore';
import systemTransitionStore from './systemTransition/systemTransitionStore';
import iamViolationStore from './monitoring/security/violations/IamViolationStore';
import jumpHostStatusStore from './rem/jumpHostStatus/jumpHostStatusStore';
import accountRequestStore from './accountManagement/accountRequest/accountRequestStore';
import accountReportStore from './accountManagement/accountReport/accountReportStore';
import maintenanceStore from './maintenance/maintenanceStore';

Vue.use(Vuex);

const state = {
  uid: '',
  errorState: '',
  isAuth: false,
  menus: [],
  locale: '',
  params: {},
  gmt: '',
  userEtcInfos: {},
  mainPath: process.env.MAIN_PATH,
};

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  modules: {
    samplePage: samplePageStore,
    gridSample: gridSampleStore,
    gridExmpl: gridExmplStore,
    accKey: accKeySummaryStore,
    accKeyDetails: accKeyDetailsStore,
    accKeyException: accKeyExceptionStore,
    accKeyList: accKeyListStore,
    breadCrumb: breadCrumbStore,
    userdiv: userdivStore,
    common: commonStore,
    webClient: webClientStore,
    remProject: remProjectStore,
    remRegion: remRegionStore,
    remUser: remUserStore,
    remLog: remLogStore,
    remDivision: remDivisionStore,
    accountDivision: accountDivisionStore,
    accountDetail: accountDetailStore,
    accountStatus: accountStatusStore,
    myHome: myHomeStore,
    systemTransition: systemTransitionStore,
    iamViolation: iamViolationStore,
    jumpHostStatus: jumpHostStatusStore,
    accountRequestStore: accountRequestStore,
    accountReportStore: accountReportStore,
    maintenance: maintenanceStore,
  },
});



// WEBPACK FOOTER //
// ./src/vuex/store.js